module.exports = __webpack_public_path__ + "img/gb1024.prt.ebd3ea4d.jpg";